export enum YapilyStatus {
  AUTHORIZED = 'AUTHORIZED',
  AWAITING_AUTHORIZATION = 'AWAITING_AUTHORIZATION',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
}
